<template>
  <v-dialog
    :value="value"
    scrollable
    persistent
  >
    <h-modifiers
      :disabled="locked"
      @complete="$emit('complete')"
      @close="$emit('input', false)"
    />
  </v-dialog>
</template>

<script>
  import Lockable from '@/Mixins/Lockable'
  import HModifiers from './Card'

  export default {
    mixins: [
      Lockable,
    ],

    components: {
      HModifiers,
    },

    props: {
      value: {
        required: true,
        type: Boolean,
      },
    },

    watch: {
      value (v) {
        this.lock(v ? 125 : 200)
      },
    },
  }
</script>
